


















import {ComparisonProduct, Component, InjectComponent, ProductProperty, ProductPropertyGroup, Prop, Vue, VueComponent} from "@zoovu/runner-browser-api";

@Component({})
export default class PropertyGroupView extends Vue {

    @Prop()
    group: ProductPropertyGroup;

    @Prop()
    shownProducts: ComparisonProduct[];

    @InjectComponent("PropertyHeaderView")
    propertyHeaderView: VueComponent;

    propertiesToFilter = ["price", "variationId"];

    groupCollapsed: boolean = false;

    filteredProperties(group: ProductPropertyGroup) {
        return group.productProperties.filter((prop) => !this.isPropertyIgnored(prop));
    }

    getProperty(propName: string, product: ComparisonProduct) {
        const property = product.properties.get(propName);
        if (property) {
            return property.displayValue;
        }
        return "—";
    }

    getClass(propName: string, product: ComparisonProduct) {
        const property = product.properties.get(propName);

        if (!property || property.rawValue.propertyType !== "BLN" || property.rawValue.value == null) {
            return undefined;
        }

        if (property.rawValue.value) {
            return "boolean-true";
        }

        return "boolean-false"
    }

    toggleGroup() {
        this.groupCollapsed = !this.groupCollapsed;
    }

    isPropertyIgnored(property: ProductProperty) {
        return this.propertiesToFilter.some((prop) => prop === property.name);
    }
}
